import { accountSettings } from "../consts/AccountSettings.const";
import { IUpdateNotificationsPayload } from "../interfaces/IUpdateNotificationsPayload";

export const updateNotifications = (payload: IUpdateNotificationsPayload): void => {
    const document = accountSettings.getDocument();

    let newValue = "";
    newValue += payload.settings.digest ? "D" : "";
    newValue += payload.settings.email ? "E" : "";
    newValue += payload.settings.feed ? "F" : "";

    const settings = document.latestModel.notifications.settings.get();
    if (settings === null) {
        return;
    }
    const item = settings[payload.type];
    if (item === undefined) {
        return;
    }

    const newItem = {
        ...item,
        value: newValue
    };
    document.latestModel.notifications.settings[payload.type].update(newItem);
};
